<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Nova Requisição de Materiais
      </p>
    </div>
    <div class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm">
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="q-ml-sm">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="q-ml-sm">Centro de Custo</div>
        <q-select
          v-model="centroCustoSelecionado"
          dense
          outlined
          option-value="id"
          :option-label="(item) => (item ? `${item.code} - ${item.name}` : '')"
          :options="centroCustosFiltrados"
          use-input
          hide-selected
          fill-input
          input-debounce="300"
          @filter="filtrarCentroCusto"
          bg-color="white"
          class="select input-new-design"
          :placeholder="
            !centroCustoSelecionado ? 'Selecione o Centro de Custo' : ''
          "
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                Nenhum centro de custo encontrado
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </div>

    <div v-if="unidade.id && centroCustoSelecionado">
      <NovaRequisicaoTabelasNew
        :unidade="unidade.id"
        :centroCustoId="centroCustoSelecionado"
        :userLogadoId="userLogadoId"
      />
    </div>
    <div
      v-else-if="unidade.id && !centroCustoSelecionado"
      class="q-mt-xl text-center text-grey-6"
    >
      <q-icon name="info" size="48px" />
      <p class="text-body1">Selecione um Centro de Custo para continuar</p>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";

import NovaRequisicaoTabelasNew from "../components/NovaRequisicaoTabelasNew.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  name: "NovaRequisicaoMateriaisNew",
  components: {
    NovaRequisicaoTabelasNew,
    ListaUnidadesSelect,
  },
  setup() {
    const store = useStore();
    let unidade = ref("");
    const centroCustoSelecionado = ref(null);
    const centroCustos = ref([]);
    const centroCustosFiltrados = ref([]);
    const userLogadoId = ref(null);

    const getCentroCustosUsuario = async () => {
      try {
        let response = await store.dispatch("requisicao/userLogado");
        userLogadoId.value = response.data.id;

        if (
          response.data.cost_centers &&
          Array.isArray(response.data.cost_centers)
        ) {
          centroCustos.value = response.data.cost_centers;
          centroCustosFiltrados.value = response.data.cost_centers;
        } else {
          centroCustos.value = [];
          centroCustosFiltrados.value = [];
        }
      } catch (error) {
        console.error("Erro ao buscar centros de custo do usuário:", error);
        centroCustos.value = [];
        centroCustosFiltrados.value = [];
      }
    };

    const filtrarCentroCusto = (val, update) => {
      if (val === "") {
        update(() => {
          centroCustosFiltrados.value = centroCustos.value;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();
        centroCustosFiltrados.value = centroCustos.value.filter(
          (cc) =>
            cc.code.toLowerCase().indexOf(needle) > -1 ||
            cc.name.toLowerCase().indexOf(needle) > -1
        );
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => unidade.value,
      () => {
        centroCustoSelecionado.value = null;
      }
    );

    onMounted(() => {
      getCentroCustosUsuario();
    });

    return {
      unidade,
      centroCustoSelecionado,
      centroCustos,
      centroCustosFiltrados,
      filtrarCentroCusto,
      userLogadoId,
    };
  },
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .col-md-3,
  .col-md-4,
  .col-sm-6,
  .col-xs-12 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .row.col-12.text-weight-bold.text-brand-5.q-mt-md.q-gutter-sm {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .col-md-3 > div,
  .col-md-4 > div,
  .col-sm-6 > div,
  .col-xs-12 > div {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .q-ml-sm {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .q-page {
    padding: 8px !important;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
